/**
 * Frontend duplicate of backend nutrient meta as a fallback.
 * Live data is fetched from /api/meta/nutrients.
 */
export const NUTRIENT_GROUPS = [
  {
    label: "Makronährstoffe",
    keys: [
      "energy_kj", "energy_kcal", "fat", "saturated_fat", "mono_fat", "poly_fat",
      "trans_fat", "cholesterol", "carbs", "sugar", "polyols", "starch",
      "fiber", "protein", "salt", "water",
    ],
  },
  {
    label: "Vitamine",
    keys: ["vit_a", "vit_d", "vit_e", "vit_k", "vit_c", "vit_b1", "vit_b2",
      "vit_b3", "vit_b5", "vit_b6", "vit_b7", "vit_b9", "vit_b12"],
  },
  {
    label: "Mineralstoffe & Spurenelemente",
    keys: ["calcium", "phosphorus", "magnesium", "iron", "zinc", "copper",
      "manganese", "selenium", "iodine", "potassium", "sodium", "chloride",
      "fluoride", "chromium", "molybdenum"],
  },
];

export function formatNum(v) {
  const n = Number(v) || 0;
  if (n === 0) return "0";
  if (Math.abs(n) >= 100) return n.toFixed(0);
  if (Math.abs(n) >= 10) return n.toFixed(1);
  return n.toFixed(2);
}

/** Wandelt Gramm in eine "X,XXX kg" String-Darstellung um (3 Nachkommastellen, deutsch). */
export function formatKg(grams) {
  const g = Number(grams) || 0;
  const kg = g / 1000;
  return kg.toLocaleString("de-DE", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("de-DE", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
